export default "__VITE_PUBLIC_ASSET__47b3d5b4__"